import Cookies from "js-cookie";

import { envChecker } from "./envChecker";

import { LOGIN_URL, MAIN_DOMAIN } from "config";
import { AUTH_COOKIES_KEY, EENV } from "constants/index";

export const logout = () => {
  const { hostname } = new URL(MAIN_DOMAIN);
  const cookieKeys = [AUTH_COOKIES_KEY.TOKEN, AUTH_COOKIES_KEY.REFRESH_TOKEN];

  try {
    cookieKeys.forEach((key) => {
      Cookies.remove(key, {
        domain: envChecker({ envs: [EENV.DEV] }) ? undefined : `.${hostname}`,
      });
    });
  } catch (err) {
    console.error(err);
  }

  setTimeout(() => {
    window.location.replace(LOGIN_URL);
  }, 500);
};
